<template>
  <apexchart
    type="line"
    height="40"
    width="100"
    :options="chartOptions"
    :series="series"
    style="justify-items: center"
  />
</template>

<script setup>
import ApexChart from "vue3-apexcharts";

const apexchart = ApexChart;

const props = defineProps({
  records: {
    type: Array,
    required: true,
  },
});

import { computed, defineProps } from "vue";

const sortedRecords = computed(() => {
  return [...props.records].sort(
    (a, b) => parseFloat(a.holdpercentage) - parseFloat(b.holdpercentage)
  );
});

const series = computed(() => [
  {
    name: "Holding %",
    data: sortedRecords.value.map((record) =>
      parseFloat(record.holdpercentage)
    ),
  },
]);

const chartOptions = computed(() => ({
  chart: {
    toolbar: { show: false },
    sparkline: { enabled: true },
  },
  xaxis: {
    categories: sortedRecords.value.map((r) => r.invdate),
    labels: { show: false },
  },
  yaxis: {
    labels: { show: false },
  },
  stroke: {
    curve: "smooth",
    width: 2,
  },
  tooltip: {
    enabled: false,
    y: {
      formatter: (val) => `${val.toFixed(2)}%`,
    },
  },
}));
</script>

<style scoped></style>
